module.exports = __webpack_public_path__ + "img/18exp.54934681.jpg";